import { FileNameSeparatorWithExtension } from '@/components/FileNameSeparatorWithExtension';
import {
  ActiveFileType,
  usePaymentDetail,
} from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/context/PaymentDetailContext';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import { Drawer } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo, useCallback, useState } from 'react';
import { Contents } from './Contents';
import styles from './Contents/styles.module.scss';
import { FileInfoDrawerProps } from './types';

const cx = classNames.bind(styles);

const FileInfoDrawerInner: FC<FileInfoDrawerProps> = memo(
  ({ open, onClose, businessDocumentId, title, onCloseDetailDrawer }) => {
    const containerRef = useGlobalContainerRef();
    const [fileName, setFileName] = useState<string>('');

    const handleFileNameLoaded = useCallback((loadedFileName: string) => {
      setFileName(loadedFileName);
    }, []);

    const displayTitle = fileName || title || '';
    const drawerTitle = displayTitle ? (
      <FileNameSeparatorWithExtension
        containerClassName={cx(styles['file-name-text'])}
      >
        {displayTitle}
      </FileNameSeparatorWithExtension>
    ) : (
      ''
    );

    return (
      <Drawer
        visible={open}
        width={456}
        onClose={onClose}
        title={drawerTitle}
        getContainer={containerRef}
        mask
      >
        <Contents
          businessDocumentId={businessDocumentId}
          onFileNameLoaded={handleFileNameLoaded}
          onCloseDetailDrawer={onCloseDetailDrawer}
        />
      </Drawer>
    );
  }
);

FileInfoDrawerInner.displayName = 'FileInfoDrawerInner';

export type FileInfoDrawerComponentProps = {
  onCloseDetailDrawer?: () => void;
};

export const FileInfoDrawer: FC<FileInfoDrawerComponentProps> = memo(
  ({ onCloseDetailDrawer }) => {
    const { showFileInfoDrawer, setShowFileInfoDrawer, activeFile } =
      usePaymentDetail();

    const handleClose = useCallback(() => {
      setShowFileInfoDrawer(false);
    }, [setShowFileInfoDrawer]);

    const businessDocumentId =
      activeFile?.type === ActiveFileType.BUSINESS_DOCUMENT
        ? activeFile.id
        : undefined;

    return (
      <FileInfoDrawerInner
        open={showFileInfoDrawer}
        onClose={handleClose}
        businessDocumentId={businessDocumentId}
        onCloseDetailDrawer={onCloseDetailDrawer}
      />
    );
  }
);
FileInfoDrawer.displayName = 'FileInfoDrawer';
